import { render, staticRenderFns } from "./ReportPerformanceChart.vue?vue&type=template&id=08017cb7&scoped=true&"
import script from "./ReportPerformanceChart.vue?vue&type=script&lang=js&"
export * from "./ReportPerformanceChart.vue?vue&type=script&lang=js&"
import style0 from "./ReportPerformanceChart.vue?vue&type=style&index=0&id=08017cb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08017cb7",
  null
  
)

export default component.exports